import { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { Modal } from "../components/elements";
import { useLouveApi } from '../hooks';
import { useAuth } from "../context/AuthContext";
import { useOrder } from "../context/OrderContext";
import { getError } from "../util";

import PaystackLogo from "../components/SVGs/PaystackLogo";
import woman from "../pages/Images/woman.png";

export default function Payment() {
  const [payment, setPayment] = useState(null);
  const [editingAddress, setEditingAddress] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { user } = useAuth();
  const { orderNow, genUID, initializePayment, onChange, address, setAmount } = useOrder();
  const history = useHistory();
  const { data: subTotal } = useLouveApi(`ShoppingCart/SubTotal/${user.user_Id}`)
  setAmount(subTotal?.subAmount)

  const handleOrder = async () => {
    const res = await orderNow();
    if (res.status >= 200 && res.status < 210) {
      genUID()
      setOpenModal(true);
      setTimeout(() => {
        history.push('/products')
      }, 2000);
    } else {
      genUID()
      getError(res)
    }
  }

  const onSuccess = (response) => {
    handleOrder()
    console.log(response);
  };

  const onClose = () => {
    console.log('closed')
    genUID()
  }

  const onChangeValue = (e) => {
    setPayment(e.target.value);
  };
  return (
    <div className="p-4 md:px-12 pt-48 pb-16 min-h-screen">
      <div className="flex flex-wrap pb-12 md:py-12 items-start">
        <div className="w-full md:w-8/12 border-2 border-t-0 border-gray3 ">
          <div className="row block md:px-8">
            <div className="col-md-12">
              <div className="bar-container">
                <div className="swiper-wrapper timeline">
                  <div className={`single-bar ${address ? "active" : null}`}>
                    <div className="timestamp"></div>
                    <div className="status">
                      <div>
                        <span style={{ right: "-50px" }}>shipping address</span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className={`single-bar ${payment ? "active" : null}`}>
                    <div className="timestamp"></div>
                    <div className="status">
                      <div>
                        <span>payment</span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className={`single-bar ${false ? "active" : null}`}>
                    <div className="timestamp"></div>
                    <div className="status">
                      <div>
                        <span>checkout</span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className={`single-bar ${false ? "active" : null}`}>
                    <div className="timestamp"></div>
                    <div className="status">
                      {/* <span>shipping address</span> */}
                    </div>
                  </div>
                </div>
                <div className="swiper-pagination"></div>
              </div>
            </div>
          </div>
          <div>
            <div className="flex items-center justify-between border-b-2 border-gray3 px-6 py-3 mt-8">
              <div className="flex items-center">
                {address && (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 9.17715V10.0051C18.9989 11.9459 18.3704 13.8344 17.2084 15.3888C16.0463 16.9432 14.413 18.0804 12.5518 18.6307C10.6907 19.1809 8.70153 19.1149 6.88102 18.4423C5.06051 17.7697 3.50619 16.5266 2.44986 14.8985C1.39354 13.2704 0.891812 11.3444 1.01951 9.40783C1.14721 7.47126 1.89749 5.62784 3.15845 4.15252C4.41942 2.67719 6.12351 1.649 8.01657 1.22128C9.90963 0.79357 11.8902 0.989255 13.663 1.77915M19 2.80516L10 11.8142L7.3 9.11416"
                      stroke="#179E01"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                )}

                <h4 className="ml-4 font-bold text-xl">1. Shipping Address</h4>
              </div>
              <button
                className="font-medium text-primary text-lg"
                onClick={() => setEditingAddress(!editingAddress)}
              >
                {editingAddress ? "SAVE" : "CHANGE"}
              </button>
            </div>
            <div className="ml-16 py-4 ">
              <h5 className="font-medium mb-2">Esther Lolade</h5>
              {!editingAddress ? (
                <p
                  className="font-light text-sm"
                  onClick={() => setEditingAddress(true)}
                >
                  {address ? address : "Please Enter Delivery address"}
                </p>
              ) : (
                <input
                  type="text"
                  name="address"
                  className="p-4 border border-gray3 focus:border-primary focus:outline-none w-6/12 rounded-md"
                  placeholder="Delivery Address ..."
                  value={address}
                  onChange={onChange}
                />
              )}
            </div>

            <div className=" mt-8">
              <div className="flex items-center px-6  border-b-2 border-gray3 py-3">
                {payment && (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 9.17715V10.0051C18.9989 11.9459 18.3704 13.8344 17.2084 15.3888C16.0463 16.9432 14.413 18.0804 12.5518 18.6307C10.6907 19.1809 8.70153 19.1149 6.88102 18.4423C5.06051 17.7697 3.50619 16.5266 2.44986 14.8985C1.39354 13.2704 0.891812 11.3444 1.01951 9.40783C1.14721 7.47126 1.89749 5.62784 3.15845 4.15252C4.41942 2.67719 6.12351 1.649 8.01657 1.22128C9.90963 0.79357 11.8902 0.989255 13.663 1.77915M19 2.80516L10 11.8142L7.3 9.11416"
                      stroke="#179E01"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                )}

                <h4 className="ml-4 font-bold text-xl">2. Payment</h4>
              </div>
              <ul className="divide-y-2 divide-gray-3" onChange={onChangeValue}>
                <li className="flex items-center p-6 ">
                  <input
                    type="radio"
                    id="cash"
                    name="payment"
                    value="cash"
                    disabled
                  />
                  <label for="cash">
                    <div
                      className="ml-10 cursor-not-allowed text-gray3"
                      title="Currently not available"
                    >
                      <div className="flex items-center mb-4">
                        <svg
                          width="42"
                          height="22"
                          viewBox="0 0 42 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M40.9471 10.8498C41.1159 11.1501 40.8627 11.3904 40.4406 11.3904H1.61159C1.10512 11.3904 0.936317 11.1501 1.02073 10.8498L5.83214 1.54054C6.00096 1.24024 6.50744 1 6.9295 1H34.5319C34.9539 1 35.5448 1.24024 35.7137 1.54054L40.9471 10.8498Z"
                            stroke="#999999"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M25.8387 5.8653C26.1764 7.54698 23.9817 8.98842 20.9429 8.98842C17.9041 8.98842 15.7094 7.48692 15.8783 5.8653C16.1315 4.3638 18.3262 3.28271 20.7741 3.28271C23.3064 3.28271 25.5855 4.42386 25.8387 5.8653Z"
                            stroke="#999999"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11.4141 6.09704C11.537 6.70918 10.7381 7.23386 9.63202 7.23386C8.52589 7.23386 7.72702 6.68732 7.78847 6.09704C7.88065 5.5505 8.67952 5.15698 9.57056 5.15698C10.4923 5.15698 11.3219 5.57236 11.4141 6.09704Z"
                            stroke="#999999"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M33.9434 6.09704C34.0663 6.70918 33.2674 7.23386 32.1613 7.23386C31.0552 7.23386 30.2563 6.68732 30.3178 6.09704C30.4099 5.5505 31.2088 5.15698 32.0999 5.15698C33.0216 5.15698 33.8512 5.57236 33.9434 6.09704Z"
                            stroke="#999999"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M2.11914 14.5737H39.8509"
                            stroke="#999999"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M2.11914 17.7568H39.8509"
                            stroke="#999999"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M2.11914 21H39.8509"
                            stroke="#999999"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <h5 className="ml-4 font-semibold">Cash on Delivery</h5>
                      </div>
                      <p className="text-sm">
                        Make payments for goods when they are delivered to you
                      </p>
                    </div>
                  </label>
                  <br />
                </li>
                <li className="flex items-center p-6 ">
                  <input
                    type="radio"
                    id="paystack"
                    name="payment"
                    value="paystack"
                  />
                  <label for="paystack">
                    <div className="ml-10 cursor-pointer">
                      <PaystackLogo className="w-32" />
                    </div>
                  </label>
                  <br />
                </li>
              </ul>
            </div>

            <div className="px-6  border-b-2 border-gray3 py-3 mt-8">
              <h4 className="ml- text-xl">SHIPMENT DETAILS</h4>
            </div>
            <ul className=" border-b-2 border-gray3">
              <li className="text-sm text-gray3 px-6 py-3">
                <h5 className="font-bold mb-2">Shipment 1 of 2</h5>
                <p className="mb-2">1x Ankara Az 2inches blah blah blah </p>
                <p className="text-xs">
                  Delivered by <span className="text-black">Tuesday 5 Oct</span>
                </p>
              </li>
              <li className="text-sm text-gray3 px-6 py-3">
                <h5 className="font-bold mb-2">Shipment 1 of 2</h5>
                <p className="mb-2">1x Ankara Az 2inches blah blah blah </p>
                <p className="text-xs">
                  Delivered by <span className="text-black">Tuesday 5 Oct</span>
                </p>
              </li>
            </ul>

            <div className="w-full md:w-4/12 p-6">
              <div className="flex items-center justify-between mb-2">
                <span className="text-base font-medium">Subtotal</span>
                <span>₦100,000</span>
              </div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-base font-medium">Delivery fee</span>
                <span>₦1,000</span>
              </div>
              <div className="flex items-center justify-between mb-2 mt-8">
                <span className="text-base font-medium">Total</span>
                <span className="text-primary text-xl font-semibold">
                  ₦51,000
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-4/12 border-2 border-t-0 md:border-l-0 border-gray3">
          <ul>
            <li className="flex items-center p-6 border-b border-gray3">
              <div className="w-3/12">
                <img src={woman} alt="" className="w-16" />
              </div>
              <div className="w-8/12">
                <p className="text-lg font-medium">Ankara Az 2inches</p>
                <p className="text-primary my-3">₦50,000</p>
                <span>Qty:1</span>
              </div>
            </li>
            <li className="flex items-center p-6  border-b border-gray3">
              <div className="w-3/12">
                <img src={woman} alt="" className="w-16" />
              </div>
              <div className="w-8/12">
                <p className="text-lg font-medium">Ankara Az 2inches</p>
                <p className="text-primary my-3">₦50,000</p>
                <span>Qty:1</span>
              </div>
            </li>
          </ul>
          <div className="border-b border-gray3 p-6">
            <div className="flex items-center justify-between mb-2">
              <span className="text-base font-medium">Subtotal</span>
              <span>₦100,000</span>
            </div>
            <div className="flex items-center justify-between mb-2">
              <span className="text-base font-medium">Delivery fee</span>
              <span>₦1,000</span>
            </div>
            <div className="flex items-center justify-between mb-2 mt-8">
              <span className="text-base font-medium">Total</span>
              <span className="text-primary text-xl font-semibold">
                ₦51,000
              </span>
            </div>
          </div>

          <Link to="/cart">
            <button className="w-full text-center text-primary hover:underline font-light capitalize py-6">
              Modify Cart
            </button>
          </Link>
        </div>
      </div>
      <button onClick={() => {
        genUID()
        initializePayment(onSuccess, onClose)
      }}
        className="bg-primary rounded-md cursor-pointer px-24 py-3 text-white text-center text-sm">
        Make Payment
      </button>

      <Modal open={openModal} setOpen={setOpenModal} autoClose>
        <div>
          <h1 className="text-inputBorder text-4xl">Purchase Successful</h1>
          <p>
            Your transaction has been completed successfully. Redirecting back
            to the main page...
          </p>
        </div>
      </Modal>
    </div>
  );
}
